/**
 *  平台用于请求cgi的统一函数
 *  1. 兼容去除或带有登录态的逻辑
 *  2. 前端监控系统cgi上报readystatechange变化时间打点
 * @module common/ajaxcall
 */

import Env from '../common/env.js';

import QMAjax from '../base/ajax.js';
import * as Base from '../base/string.js';
import Dom from '../base/mdom.js';
import mbase from '../base/mbase.js';
import Cookie from '../base/cookie.js';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import _qualityBase from '../quality/quality_report_base.js';
var getQueryStr     = mbase.getQueryStr;
import jsapiLog from '../jsbridge/jsapi_log.js';
import * as util from '../common/util';


function isBlobData(body) {
    if (body instanceof Blob) {
        return true;
    }else if (typeof body === 'object') { // <key, value>，只处理一层结构即可
        return Object.keys(body).some(key => {
            return body[key] instanceof Blob
        });
    }  
    return false;
}

/**
 * @static
 * @param {string} cgi
 * @param {Object|String} params        - 请求的参数，如果是POST方式，将会加到body中，否则加在url上 { method: 'GET'/'POST', timeout: 30000 }
 * @param {string} [params.method='GET']
 * @param {number} [params.timeout=30000]
 * @param {callback} scallback   - 成功请求的回调函数
 * @param {object} scallback.res - 解析xhr内容所得到的对象
 * @param {callback} fcallback   - 失败请求的回调函数
 * @param {number} fcallback.errcode      - 失败请求的返回码
 *
 * @example
 * import xhrCallCgi from 'common/ajaxcall';
 * usage 1: 发post请求 发post请求 发post请求 发post请求
 * xhrCallCgi(
 *  '/cgi-bin/gamewap/getgamelibinfo',
 *  {
 *      labelid: xxxx,
 *      limit: 10,
 *      method:'POST'
 *  },
 *  function(res) {
 *      //do with res - eg. {errcode: xxx, errmsg: xxx, data:...}
 *  },
 *  function(errcode) {
 *      // do with errcode
 *  }
 * )
 *
 *  发GET请求 发GET请求 发GET请求 发GET请求
 * xhrCallCgi(
 *  '/cgi-bin/gamewap/getgamelibinfo',
 *  {
 *      labelid: xxxx,
 *      limit: 10,
 *      method:'GET'
 *  }),
 *  function(res) {
 *      //do with res - eg. {errcode: xxx, errmsg: xxx, data:...}
 *  },
 *  function(errcode) {
 *      // do with errcode
 *  }
 * )
 */

function xhrCallCgi(cgi, params, scallback, fcallback) {
    var _oSelf = this;
    var tparam = params || {};
    /*
    *	@desc 以下这句话，是为了解决 can't create property on string的问题。
    *   意思是string.xxx 是会报错的。chrome 56.0.2924.87 m 20170420
    */
    if('string' === typeof tparam ){
        try {
            tparam = JSON.parse(tparam);
        } catch (error) {
            tparam = Base.strToMap(tparam);
        }
    }

    // 透传数据mock参数
    var cgiMockKey = getQueryStr("cgi_mock_key",null,Dom.window);
    if(cgiMockKey) {
        tparam.cgi_mock_key = cgiMockKey;
    }
    tparam.needLogin = (undefined != tparam.needLogin) ? tparam.needLogin : true;
    var sendParam = {
        cgi     : cgi,
        params  : params,
        login   : {},
        tparam  : tparam
    };

    if( tparam.needLogin ){
        wxBridge.getUinKey(function(login){
            sendParam.login = login;
            sendXhr.call(_oSelf,sendParam,scallback, fcallback);
        });
    }else{
        sendParam.login = {};
        sendXhr.call(_oSelf,sendParam,scallback, fcallback);
    }
}
function sendXhr(sendParam,scallback, fcallback){
    var _oSelf = this;
    var cgi         = sendParam.cgi;
    var params      = sendParam.params;
    var login       = sendParam.login;
    var tparam      = sendParam.tparam;

    tparam.method   = tparam.method  || 'GET';
    var timeout     = tparam.timeout || 30000;
    var method      = tparam.method;
    var contentType = tparam.contentType // 手动指定 contentType，如 multipart/form-data

    /*
    *	@desc 兼容登陆逻辑。5.8日添加，注意这里的uin,key,千万别用wxBridge.getUinKey来获取。
    *   因为这里是用于任何场景的，不管它有没有wepkg，都只用于兼容。如果有wepkg时，调用getUinKey获取后，
    *   必定又把uin,key,pass_ticket给传给 cgi了。这里只是兼容。本来是不想传给cgi的。
    */

    var loginInfo = {
        uin         : login.uin,
        key         : login.key
    };
    var ticketInfo = {
        pass_ticket : login.pass_ticket
    };
    var abtestCookie = getQueryStr('abtest_cookie',null,Dom.window)
    var abt          = getQueryStr('abt',null,Dom.window);

    tparam.abtest_cookie = tparam.abtest_cookie || abtestCookie;
    tparam.abt           = tparam.abt           || abt;

    if(typeof params === 'string') {
        try {
            var jsonParams = JSON.parse(params);
            if(window.__KULP_BUILD_VERSION__) {
                jsonParams.build_version = window.__KULP_BUILD_VERSION__;
            }
            params = JSON.stringify(jsonParams);
        }catch (e) {
        }
    }
    if(window.__KULP_BUILD_VERSION__) {
        tparam.build_version = __KULP_BUILD_VERSION__;
    }

    var accessTokenInfo = {};
    if( !!login.openid ){
        accessTokenInfo.openid = login.openid;
    }
    if( !!login.access_token ){
        accessTokenInfo.access_token = login.access_token;
    }


    var msdkParams;

    if(Env.isMSDK) {
        msdkParams = util.getInGameLoginByType()
    }

    if ('get' === method.toLowerCase()) {

        /*
        *	@desc 如果有登陆态，就是开平还 没停止 下发 登陆态 到 url
        *   顺便把tparam里有的登陆态，给覆盖一下。
        */

        /*
        * @desc 为了兼容，去登陆态。并不会删除pass_ticket的问题。
        */

        if( !!ticketInfo.pass_ticket && !!!getQueryStr('pass_ticket',cgi) ){
            tparam = mbase.extend(tparam,ticketInfo);
        }

        if( !!loginInfo.uin && !!!getQueryStr('uin',cgi) ){
            tparam = mbase.extend(tparam,loginInfo);
        }

        if( !!accessTokenInfo.access_token && !!!getQueryStr('access_token',cgi) ){
            tparam = mbase.extend(tparam,accessTokenInfo);
        }

        cgi = cgi + (cgi.indexOf('?') == -1 ? '?' : '&') + Base.mapToStr(tparam) + (msdkParams ? ('&' + msdkParams) : '');

    } else {
        /*
            POST情况下，检查cgi是否有自己拼接登录态
            如果没有，只拼接登录态信息在cgi上, 防止将其他的body的参数信息拼接在url上

            2017.9.7
        */
        var exparam = {};

        exparam.abtest_cookie = tparam.abtest_cookie;
        exparam.abt = tparam.abt;
        exparam.build_version = tparam.build_version || 0;
        if(tparam.cgi_mock_key){
            exparam.cgi_mock_key = tparam.cgi_mock_key;
        }

        if( !!ticketInfo.pass_ticket && !!!getQueryStr('pass_ticket',cgi) ){
            exparam = mbase.extend(exparam,ticketInfo);
        }

        if( !!loginInfo.uin && !!!getQueryStr('uin',cgi) ){
            exparam = mbase.extend(exparam,loginInfo);
        }

        if( !!accessTokenInfo.access_token && !!!getQueryStr('access_token',cgi) ){
            exparam = mbase.extend(exparam,accessTokenInfo);
        }

        cgi = cgi + (cgi.indexOf('?') == -1 ? '?' : '&') + Base.mapToStr(exparam) + (msdkParams ? ('&' + msdkParams) : '');;
    }
    /**
     * 开始添加 cgi的返回码上报。
     */
    var WXGAME  = window.WXGAME        || {};
    var qualityBase = WXGAME.baseQualityReport || _qualityBase;
    var qbInstance = qualityBase.StartLogic(
        qualityBase.LOGIC_CONST.TypeTextEnum.CGI,
        cgi,tparam,wxBridge
    );
    var _QMAjax = new QMAjax(cgi, method, timeout);
    var t0 = (new Date()).getTime();


    _QMAjax.onComplete = function (xhr) {

        var res = {};
        var temp = (xhr.responseText || '');

        try {
            temp = temp.trim(); // 去掉前后的一些终止符，应该是有部分旧的接口有问题
            res = JSON.parse(temp);
        } catch (e) {
            try {
                res = new Function('return ' + temp)();
            } catch (e) {
                res = {};
            }
        }
        /**
         * 增加请求，完成后打印结果。
         */
        setTimeout(function() {
            jsapiLog.logInfo('xhrCallCgi','onComplete',cgi,res);
        }, 0)

        scallback && scallback.call(_oSelf, res);

        var t1 = (new Date()).getTime();

        // 设置返回码
        var ret;
        if ('ret' in res) {
            ret = res.ret;
        } else {
            if (res.base && ('ret' in res.base)) {
                ret = res.base.ret;
            } else {
                if('errcode' in res){
                    ret = res.errcode;
                }else{
                    ret = 9999;
                }
            }
        }

        if( 0 != ret * 1 ){
            var level = xhr.getResponseHeader("X-WXGAME-ERRLEVEL");
            /*
                1-TRACE
                2-DEBUG
                3-INFO
                4-WARN
                5-ERROR
                6-FATAL
                大于INFO的上报错误
            */
            if( !level || Number(level) > 3 ) {
                qbInstance.EndLogic({
                    errcode : ret,
                    webtransfer: !!xhr.webTransferConfig
                });
            }
        }

        if ( Math.random() * 100 < 10) { // CGI 测速，抽样10%上报
            var cost_time = {
                pa: xhr.timeArr[1] - xhr.timeArr[0],
                pb: xhr.timeArr[2] - xhr.timeArr[1],
                pc: xhr.timeArr[3] - xhr.timeArr[2],
                pd: xhr.timeArr[4] - xhr.timeArr[3],
                status: 'ok'
            };

            qbInstance.EndLogic({
                time_list : JSON.stringify(cost_time),
                webtransfer: !!xhr.webTransferConfig
            });
        }


        try{
            if(res && res.report_info && res.report_info.exp_rpt_list && res.report_info.exp_rpt_list.length > 0){
                window._expRptList_ = (window._expRptList_ || []).concat(res.report_info.exp_rpt_list);
            }
        }catch(e){}


    };
    _QMAjax.onError = function (xhr, errcode, statusCode) {
        qbInstance.EndLogic({
            errcode:errcode,
            webtransfer: !!xhr.webTransferConfig
        });

        if ('ok' != errcode) {
            fcallback && fcallback.call(_oSelf, errcode, statusCode);
        }

        var res = {};
        try {
            res = (new Function('return ' + xhr.responseText))() || {};
        } catch (e) {
            res = {
                responseText: xhr.responseText
            };
        }

        jsapiLog.logError('xhrCallCgi','onError',xhr,res,errcode,cgi);


        var t1 = (new Date()).getTime();

        // 设置返回码
        var ret;
        try {
            if ( !isNaN(res.errcode) ) {
                ret = res.errcode;
            } else if ( !isNaN(res.ret) ) {
                ret = res.ret;
            } else {
                ret = 999999;
            }
        } catch(e) {
            ret = 404;
        }

        if ('ret' in res) {
            res.ret = res.ret;
        } else {
            if (res.base && ('ret' in res.base)) {
                res.ret = res.base.ret;
            } else {
                if('errcode' in res){
                    res.ret = res.errcode;
                }else{
                    res.ret = 0;
                }

            }
        }

        if( Math.random() * 100 < 10 ) { // CGI 测速，抽样10%上报
            var cost_time = {
                pa: xhr.timeArr[1] - xhr.timeArr[0],
                pb: xhr.timeArr[2] - xhr.timeArr[1],
                pc: xhr.timeArr[3] - xhr.timeArr[2],
                pd: xhr.timeArr[4] - xhr.timeArr[3],
                status: 'fail'
            };
            qbInstance.EndLogic({
                time_list: JSON.stringify(cost_time),
                webtransfer: !!xhr.webTransferConfig
            })
        }


    };

    if (Env.isiOS && window.wgclient?.wkGameInterceptMethod === 2 ) { // 使用httpSchema方案，客户端会注入这个变量
        if (isBlobData(params)) { // 发现有使用ajax发送blob请求的情况，就做一下上报并且直接返回（不直接返回，继续发送请求会导致客户端crash）
            var schemaInstance = qualityBase.StartRunner('httpSchemaCrash', {});
            schemaInstance.EndLogic({
                err_msg: cgi
            });
            return _QMAjax
        }
    }

    if (contentType === 'multipart/form-data' && 'object' === typeof params) {
        jsapiLog.logInfo('xhrCallCgi', cgi, params, timeout);
        _QMAjax.send(params, { contentType });
    } else if ('string' == typeof params) {
        /*
        *	@desc 这里是给我们特定的cgi发送 非  & = 形式的请求。
        *   一般用于POST
        */
        jsapiLog.logInfo('xhrCallCgi',cgi,params,timeout);
        _QMAjax.send(params);
    } else {
        /*
        *	@desc 这里是给我们特定的cgi发送  & = 形式的请求。
        *   不限请求方式。
        */
        jsapiLog.logInfo('xhrCallCgi',cgi,params,timeout);
        _QMAjax.send(Base.mapToStr(tparam));
    }

    // 增加请求对象的返回
    return _QMAjax;
}

var exportData;
if(!Env.isCSR) {
    var win = window;
    if ( win['WXGAME'] && win['WXGAME'].xhrCallCgi && !Env.isMSDK) {
        exportData = win['WXGAME'].xhrCallCgi;
    }else{
        exportData = xhrCallCgi;
    }
}else{
    exportData = function(cgi, params, scallback, fcallback) {
        if('string' === typeof params ){
            try {
                params = JSON.parse(params);
            } catch (error) {
                params = Base.strToMap(params);
            }
        }
        let base = {
            method: params.method.toUpperCase(),
            url: cgi,
        };
        delete params.method;
        if(base.method.toUpperCase() === 'POST') {
            base.body = params;
            base.json = true;
        }else{
            var str = '';
            for(var key in params) {
                str += `${key}=${encodeURIComponent(params[key])}&`
            }
            base.url = base.url + (base.url.indexOf('?') > -1 ? str : `?${str}`);
            base.json = true;
        }
        Env.getCSR().request(base, function(body) {
            scallback && scallback(body);
        }, function(body) {
            fcallback && fcallback(body);
        })
    }
}

export default exportData;